import { disableScroll, enableScroll } from "../../helpers/helpers";
import MenuHandler from "./MenuHandler";

export default class MobileMenu {
    private mobileMenuWrapper: HTMLElement | null;
    private hamburgerButton: HTMLElement | null;
    private isOpen: boolean;

    private menuWrapperClass = ".header-right-side";
    private activeMobileMenuClass = "header-right-side--open";

    private hamburgerButtonClass = ".header-hamburger-container";
    private activeHamburgerClass = "header-hamburger-container--active";

    constructor() {
        this.mobileMenuWrapper = document.querySelector(this.menuWrapperClass);
        this.hamburgerButton = document.querySelector(this.hamburgerButtonClass);
        this.isOpen = false;
    }

    public init = async () => {
        if (!this.hamburgerButton) return;

        this.hamburgerButton.addEventListener("click", this.handleMenu);

        new MenuHandler().init();
    };

    public destroy = async () => {
        this.hamburgerButton?.classList.remove(this.activeHamburgerClass);
        this.mobileMenuWrapper?.classList.remove(this.activeMobileMenuClass);

        new MenuHandler().destroy();
    };

    private handleMenu = () => {
        this.isOpen = !this.isOpen;

        this.isOpen ? disableScroll() : enableScroll();
        this.hamburgerButton?.classList.toggle(this.activeHamburgerClass);
        this.mobileMenuWrapper?.classList.toggle(this.activeMobileMenuClass);
    };
}
